if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.variantSubmitDisabled = this.submitButton.hasAttribute('disabled');
        this.variantSubmitText = this.submitButtonText.textContent;
        this.refreshQuantityAvailability();

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (!this.validateQuantity()) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      get quantityInput() {
        // The PDP quantity input belongs to this form via its form attribute.
        return this.form.elements.namedItem('quantity') ||
          this.closest('product-info')?.querySelector('.quantity__input');
      }

      validateQuantity() {
        const input = this.quantityInput;
        if (!input) return true;
        const value = Number(input.value);
        const min = input.hasAttribute('min') ? Number(input.min) : 1;
        const max = input.hasAttribute('max') ? Number(input.max) : null;
        const step = Number(input.step) || 1;
        const exhausted = input.dataset.fmsQuantityExhausted === 'true';
        let message = '';
        if (exhausted) {
          message = 'Maximum quantity is already in your cart for this option.';
        } else if (!input.value.trim() || !Number.isSafeInteger(value) || value <= 0 || value < min ||
          (max !== null && value > max) || (value - min) % step !== 0) {
          message = max === null
            ? `Enter a whole-number quantity of at least ${min}, in increments of ${step}.`
            : `Enter a whole-number quantity from ${min} to ${max}, in increments of ${step}.`;
        }
        input.setCustomValidity(message);
        if (message) {
          this.handleErrorMessage(message);
          input.reportValidity();
          return false;
        }
        return true;
      }

      refreshQuantityAvailability() {
        const exhausted = this.quantityInput?.dataset.fmsQuantityExhausted === 'true';
        this.submitButton.toggleAttribute('disabled', this.variantSubmitDisabled || exhausted);
        this.submitButtonText.textContent = exhausted && !this.variantSubmitDisabled
          ? 'Maximum already in cart'
          : this.variantSubmitText;
        // Express checkout must not bypass an exhausted quantity selection.
        this.querySelectorAll('.shopify-payment-button').forEach((button) => {
          if (exhausted && !button.hidden) {
            button.dataset.fmsQuantityHidden = 'true';
            button.hidden = true;
          } else if (!exhausted && button.dataset.fmsQuantityHidden === 'true') {
            button.hidden = false;
            delete button.dataset.fmsQuantityHidden;
          }
        });
      }

      toggleSubmitButton(disable = true, text) {
        this.variantSubmitDisabled = disable;
        this.variantSubmitText = disable
          ? (text || this.submitButtonText.textContent)
          : window.variantStrings.addToCart;
        this.refreshQuantityAvailability();
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
